/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VirtualHealthLibraryStrictHttpResponse } from '../../virtual-health-library-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaHtmlResponse } from '../../models/media-html-response';

export interface MediaMediaItemRawGet$Params {
  mediaId?: string;
}

export function mediaMediaItemRawGet(http: HttpClient, rootUrl: string, params?: MediaMediaItemRawGet$Params, context?: HttpContext): Observable<VirtualHealthLibraryStrictHttpResponse<MediaHtmlResponse>> {
  const rb = new RequestBuilder(rootUrl, mediaMediaItemRawGet.PATH, 'get');
  if (params) {
    rb.query('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VirtualHealthLibraryStrictHttpResponse<MediaHtmlResponse>;
    })
  );
}

mediaMediaItemRawGet.PATH = '/Media/MediaItemRAW';
